import React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const NumberIcon: React.ComponentType<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 214 102">
    <svg fill="none">
      <path fill="#F9FBFD" d="M0 0h214v102H0z" />
      <path
        d="M21.39 60v-9.184h1.163v8.19h4.018V60h-5.18zm9.33.168c-.42 0-.822-.08-1.205-.238a3.014 3.014 0 01-.994-.686 3.568 3.568 0 01-.7-1.12 4.281 4.281 0 01-.252-1.512c0-.57.084-1.073.252-1.512.178-.448.411-.826.7-1.134.29-.308.621-.541.994-.7a3.112 3.112 0 011.204-.238 3.01 3.01 0 012.198.938c.29.308.518.686.686 1.134.178.439.266.943.266 1.512a4.08 4.08 0 01-.266 1.512 3.378 3.378 0 01-.686 1.12 2.97 2.97 0 01-1.008.686 3.01 3.01 0 01-1.19.238zm0-.952c.289 0 .555-.06.797-.182a1.86 1.86 0 00.616-.532 2.53 2.53 0 00.406-.826c.094-.317.14-.672.14-1.064s-.046-.747-.14-1.064a2.514 2.514 0 00-.406-.84 1.678 1.678 0 00-.616-.532 1.656 1.656 0 00-.798-.196c-.289 0-.555.065-.798.196a1.797 1.797 0 00-.63.532 2.687 2.687 0 00-.392.84c-.093.317-.14.672-.14 1.064s.047.747.14 1.064c.094.317.224.593.392.826.178.224.388.401.63.532.243.121.51.182.798.182zm5.09.784v-6.804h.952l.098 1.232h.042c.234-.43.514-.77.84-1.022.336-.252.7-.378 1.092-.378.27 0 .514.047.728.14l-.224 1.008a1.825 1.825 0 00-.658-.112c-.29 0-.592.117-.91.35-.308.233-.578.64-.812 1.218V60H35.81zm7.625.168a3.47 3.47 0 01-1.288-.238 3.275 3.275 0 01-1.036-.7 3.377 3.377 0 01-.686-1.12 4.166 4.166 0 01-.252-1.498c0-.56.084-1.06.252-1.498.177-.448.406-.826.686-1.134.29-.308.616-.541.98-.7a2.677 2.677 0 011.134-.252 2.8 2.8 0 011.148.224c.345.15.63.364.854.644.233.28.41.616.532 1.008.121.392.182.83.182 1.316 0 .121-.005.243-.014.364 0 .112-.01.21-.028.294h-4.592c.047.728.27 1.307.672 1.736.41.42.943.63 1.596.63.327 0 .625-.047.896-.14a4.22 4.22 0 00.798-.392l.406.756c-.299.187-.63.35-.994.49s-.78.21-1.246.21zm-2.142-4.116h3.64c0-.69-.15-1.213-.448-1.568-.29-.364-.7-.546-1.232-.546-.243 0-.476.047-.7.14-.215.093-.41.233-.588.42a2.27 2.27 0 00-.448.658 3.15 3.15 0 00-.224.896zM47.774 60v-6.804h.951l.098.98h.042c.3-.327.621-.597.966-.812a2.11 2.11 0 011.148-.336c.523 0 .93.117 1.218.35.3.224.518.541.658.952.355-.392.71-.705 1.064-.938a2.08 2.08 0 011.176-.364c.7 0 1.218.224 1.554.672.346.448.518 1.11.518 1.988V60H56.02v-4.158c0-.644-.102-1.106-.308-1.386-.205-.29-.522-.434-.952-.434-.513 0-1.082.35-1.708 1.05V60h-1.148v-4.158c0-.644-.102-1.106-.308-1.386-.205-.29-.527-.434-.966-.434-.513 0-1.082.35-1.708 1.05V60h-1.148zm12.359-4.886a.846.846 0 01-.602-.238.882.882 0 01-.238-.63c0-.27.08-.485.238-.644a.822.822 0 01.602-.252c.224 0 .415.084.574.252.168.159.252.373.252.644a.855.855 0 01-.252.63.782.782 0 01-.574.238zm0 5.054a.846.846 0 01-.602-.238.882.882 0 01-.238-.63c0-.27.08-.485.238-.644a.822.822 0 01.602-.252c.224 0 .415.084.574.252.168.159.252.373.252.644a.855.855 0 01-.252.63.782.782 0 01-.574.238z"
        fill="#757575"
      />
      <rect
        opacity={0.4}
        x={79}
        y={25}
        width={114}
        height={8}
        rx={4}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={79}
        y={75}
        width={89}
        height={8}
        rx={4}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={20}
        y={25}
        width={36}
        height={8}
        rx={4}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={20}
        y={75}
        width={29}
        height={8}
        rx={4}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={174}
        y={75}
        width={8}
        height={8}
        rx={4}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <path
        opacity={0.6}
        d="M79.64 60v-.784a167.64 167.64 0 002.048-2.08 21.324 21.324 0 001.504-1.712c.405-.533.715-1.019.928-1.456.213-.448.32-.88.32-1.296 0-.587-.16-1.067-.48-1.44-.32-.373-.805-.56-1.456-.56a2.07 2.07 0 00-1.184.368 4.734 4.734 0 00-.992.864l-.752-.752a5.71 5.71 0 011.36-1.12c.48-.288 1.056-.432 1.728-.432.95 0 1.696.277 2.24.832.544.544.816 1.27.816 2.176 0 .48-.107.965-.32 1.456a7.92 7.92 0 01-.864 1.504c-.363.512-.8 1.05-1.312 1.616a73.403 73.403 0 01-1.664 1.776c.277-.021.565-.043.864-.064.299-.021.581-.032.848-.032h2.96V60H79.64zm11.447.192c-1.035 0-1.84-.459-2.416-1.376-.576-.917-.864-2.235-.864-3.952s.288-3.024.864-3.92c.576-.896 1.381-1.344 2.416-1.344 1.024 0 1.824.448 2.4 1.344.576.896.864 2.203.864 3.92s-.288 3.035-.864 3.952c-.576.917-1.376 1.376-2.4 1.376zm0-1.056c.299 0 .566-.08.8-.24.245-.17.454-.427.624-.768.181-.352.32-.795.416-1.328.096-.544.144-1.19.144-1.936 0-.747-.048-1.387-.144-1.92-.096-.533-.235-.965-.416-1.296-.17-.341-.379-.592-.624-.752a1.386 1.386 0 00-.8-.24c-.299 0-.57.08-.816.24-.245.16-.459.41-.64.752-.17.33-.304.763-.4 1.296-.096.533-.144 1.173-.144 1.92 0 1.493.181 2.581.544 3.264.373.672.859 1.008 1.456 1.008zm8.103 1.056c-1.034 0-1.84-.459-2.416-1.376-.576-.917-.864-2.235-.864-3.952s.288-3.024.864-3.92c.576-.896 1.382-1.344 2.416-1.344 1.024 0 1.824.448 2.4 1.344.576.896.864 2.203.864 3.92s-.288 3.035-.864 3.952c-.576.917-1.376 1.376-2.4 1.376zm0-1.056c.299 0 .566-.08.8-.24.246-.17.454-.427.624-.768.182-.352.32-.795.416-1.328.096-.544.144-1.19.144-1.936 0-.747-.048-1.387-.144-1.92-.096-.533-.234-.965-.416-1.296-.17-.341-.378-.592-.624-.752a1.386 1.386 0 00-.8-.24c-.298 0-.57.08-.816.24-.245.16-.458.41-.64.752-.17.33-.304.763-.4 1.296-.096.533-.144 1.173-.144 1.92 0 1.493.182 2.581.544 3.264.374.672.859 1.008 1.456 1.008z"
        fill="#212121"
      />
    </svg>
  </SvgIcon>
);

export default NumberIcon;
